<template>
	<div class="error-code-container">
		<div class="page-header">
			<h2>{{ $t('errHub.title') }}</h2>
			<p class="subtitle">{{ $t('errHub.subtitle') }}</p>
		</div>

		<div class="filter-bar">
			<input v-model="searchQuery" type="text" :placeholder="$t('errHub.searchPlaceholder')"
				class="search-input" />
		</div>

		<div class="tabs-container">
			<div class="tabs-header">
				<button v-for="tab in i18nTabs" :key="tab.key" :class="['tab-btn', { active: currentTab === tab.key }]"
					@click="currentTab = tab.key">
					{{ tab.label }}
					<span class="badge">{{ getFilteredData(tab.key).length }}</span>
				</button>
			</div>

			<div class="tabs-content">
				<div class="table-wrapper">
					<table class="error-table">
						<thead>
							<tr>
								<th width="30%">{{ $t('errHub.thCode') }}</th>
								<th width="30%">{{ $t('errHub.thName') }}</th>
								<th width="40%">{{ $t('errHub.thMsg') }}</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in getFilteredData(currentTab)" :key="index">
								<td><span class="code-tag">{{ item.code }}</span></td>
								<td class="constant-name">{{ item.name }}</td>
								<td class="message-text">{{ item.msg }}</td>
							</tr>
							<tr v-if="getFilteredData(currentTab).length === 0">
								<td colspan="3" class="empty-cell">{{ $t('errHub.empty') }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		mounted() {},
		name: 'ErrorCodeHub',
		data() {
			return {
				// 当前激活的标签页
				currentTab: 'param',
				// 全局搜索关键字
				searchQuery: '',
				// 1. ParamValidatedExceptionConstant.java 影子数据
				paramData: [{
						code: '600000',
						name: 'Param_Default_Exception'
					},
					{
						code: '600001',
						name: 'Phone_Num_Not_Null'
					},
					{
						code: '600002',
						name: 'Req_Sms_Code_Type_Not_Null'
					},
					{
						code: '600003',
						name: 'Img_Code_Not_Null'
					},
					{
						code: '600004',
						name: 'Img_Uuid_Not_Null'
					},
					{
						code: '600005',
						name: 'Zone_Not_Null'
					},
					{
						code: '600006',
						name: 'Zone_Length_Error'
					},
					{
						code: '600007',
						name: 'Email_Address_Not_Null'
					},
					{
						code: '600008',
						name: 'Email_Format_illegality'
					},
					{
						code: '600009',
						name: 'Register_Type_Not_Null'
					},
					{
						code: '600010',
						name: 'Nick_Name_Not_Null'
					},
					{
						code: '600011',
						name: 'Avatar_Not_Null'
					},
					{
						code: '600012',
						name: 'Password_Not_Null'
					},
					{
						code: '600013',
						name: 'Password_Length_Error'
					},
					{
						code: '600014',
						name: 'Password_Format_Error'
					},
					{
						code: '600015',
						name: 'SmsCode_Not_Null'
					},
					{
						code: '600016',
						name: 'Login_Type_Not_Null'
					},
					{
						code: '600017',
						name: 'BluetoothAddressNotNull'
					},
					{
						code: '600018',
						name: 'DeviceInfoEnvironmentNotNull'
					},
					{
						code: '600019',
						name: 'DeviceSerialNumberNotNull'
					},
					{
						code: '600021',
						name: 'DeviceTypeIdNotNull'
					},
					{
						code: '600022',
						name: 'DeviceLockCommandNotNull'
					},
					{
						code: '600023',
						name: 'ClientIdNotNull'
					},
					{
						code: '600024',
						name: 'grantTypeNotNull'
					},
					{
						code: '600025',
						name: 'CellMateProWorkModeMinCycleValue'
					},
					{
						code: '600026',
						name: 'CellMateProWorkModeMAxCycleValue'
					},
					{
						code: '600027',
						name: 'CellMateProWorkModeValueNotNull'
					},
					{
						code: '600028',
						name: 'CellMateProWorkModeMinValue'
					},
					{
						code: '600029',
						name: 'CellMateProWorkModeMAxValue'
					},
					{
						code: '600030',
						name: 'CellMateProTimingMinValue'
					},
					{
						code: '600031',
						name: 'CellMateProTimingMAxValue'
					},
					{
						code: '600032',
						name: 'CellMateProShockVoltMinValue'
					},
					{
						code: '600033',
						name: 'CellMateProShockVoltMaxValue'
					},
					{
						code: '600034',
						name: 'CellMateProShockModelMaxValue'
					},
					{
						code: '600035',
						name: 'CellMateProShockModelMinValue'
					},
					{
						code: '600036',
						name: 'CellMateProShockTimingDurationMinValue'
					},
					{
						code: '600037',
						name: 'CellMateProShockTimingDurationMaxValue'
					},
					{
						code: '600038',
						name: 'CellMateProShockDurationMaxValue'
					},
					{
						code: '600039',
						name: 'CellMateProShockDurationMinValue'
					}
				],
				// 2. ServiceExceptionEnum.java 影子数据
				serviceData: [{
						code: '401',
						name: 'PlatformApiTokenExpired'
					},
					{
						code: '500000',
						name: 'DefaultException'
					},
					{
						code: '500001',
						name: 'PhoneNumberNull'
					},
					{
						code: '500002',
						name: 'ImgCodeError'
					},
					{
						code: '500003',
						name: 'PhoneNumberNotExist'
					},
					{
						code: '500004',
						name: 'PhoneNumberAlreadyExists'
					},
					{
						code: '500005',
						name: 'SmsCodeSendInterval'
					},
					{
						code: '500006',
						name: 'SmsCodeSendCountMax'
					},
					{
						code: '500007',
						name: 'SmsCodeSendFailed'
					},
					{
						code: '500008',
						name: 'EmailCodeSendFiled'
					},
					{
						code: '500009',
						name: 'EmailAddressNotExists'
					},
					{
						code: '500010',
						name: 'EmailAddressAlreadyExists'
					},
					{
						code: '500011',
						name: 'RequestBodyEmpty'
					},
					{
						code: '500012',
						name: 'SmsCodeError'
					},
					{
						code: '500013',
						name: 'EmailAddressEmpty'
					},
					{
						code: '500014',
						name: 'SysUserNotExists'
					},
					{
						code: '500015',
						name: 'PasswordNotNull'
					},
					{
						code: '500016',
						name: 'SysUserLoginError'
					},
					{
						code: '500017',
						name: 'SysUsernameOrPasswordError'
					},
					{
						code: '500018',
						name: 'PlatformSecretInfoNull'
					},
					{
						code: '500019',
						name: 'RequestHeaderNotEnvironmentKey'
					},
					{
						code: '500020',
						name: 'RequestHeaderEnvironmentKeyIllegality'
					},
					{
						code: '500021',
						name: 'DecryptFailed'
					},
					{
						code: '500022',
						name: 'DeviceNotExists'
					},
					{
						code: '500023',
						name: 'DeviceAlreadyExists'
					},
					{
						code: '500024',
						name: 'AddDeviceError'
					},
					{
						code: '500025',
						name: 'DeviceBindingWithOtherPlatform'
					},
					{
						code: '500026',
						name: 'DeviceNotBelongsPlatform'
					},
					{
						code: '500027',
						name: 'ReleaseDeviceFailed'
					},
					{
						code: '500028',
						name: 'TestEnvironmentOnlyOneDevice'
					},
					{
						code: '500029',
						name: 'Bluetooth_Connection_Error'
					},
					{
						code: '500030',
						name: 'GetDeviceTokenError'
					},
					{
						code: '500031',
						name: 'DeviceTokenIsInvalid'
					},
					{
						code: '500032',
						name: 'GetKeyPodUnlockCmdFailure'
					},
					{
						code: '500033',
						name: 'GetKeyPodLockCmdFailure'
					},
					{
						code: '500034',
						name: 'GetKeyPodStateCmdFailure'
					},
					{
						code: '500035',
						name: 'GetKeyPodShutdownCmdFailure'
					},
					{
						code: '500036',
						name: 'PlatformNotBindDevice'
					},
					{
						code: '500037',
						name: 'PlatformClientIdInvalid'
					},
					{
						code: '500038',
						name: 'PlatformImportanceInfoDeficiency'
					},
					{
						code: '500039',
						name: 'PlatformInfoInvalid'
					},
					{
						code: '500040',
						name: 'RefreshPlatformApiTokenFailure'
					},
					{
						code: '500041',
						name: 'UsernameAndPasswordNotMatch'
					},
					{
						code: '500042',
						name: 'ExistTimingError'
					},
					{
						code: '500043',
						name: 'CmdCallbackStatusFailure'
					},
					{
						code: '500044',
						name: 'SecretKeyNotMatchDeviceEnvironment'
					},
					{
						code: '500045',
						name: 'GetCellMateNotifyCmdFailure'
					},
					{
						code: '500046',
						name: 'GetCellMateProWorkModelFailure'
					},
					{
						code: '500047',
						name: 'GetCellMateProUnLockCmdFailure'
					},
					{
						code: '500048',
						name: 'GetCellMateProTimingUnlockCmdFailure'
					},
					{
						code: '500049',
						name: 'GetCellMateProClearTimingUnlockCmdFailure'
					},
					{
						code: '500050',
						name: 'GetCellMateProShockImmediatelyShockCmdFailure'
					},
					{
						code: '500051',
						name: 'GetCellMateProShockContinuedFiveSecondFailure'
					},
					{
						code: '500052',
						name: 'GetCellMateProStopAllShockCmdFailure'
					},
					{
						code: '500053',
						name: 'GetCellMateProTimingShockCmdFailure'
					},
					{
						code: '500054',
						name: 'GetCellMateProClearTimingElectricShockFailure'
					},
					{
						code: '500055',
						name: 'GetCellMateProLocationCmdFailure'
					},
					{
						code: '500056',
						name: 'GetCellMateProDisplayDirectionCmdFailure'
					},
					{
						code: '500057',
						name: 'GetCellMateProServerIpAndPortCmdFailure'
					},
					{
						code: '500058',
						name: 'Toy_Call_Back_Cmd_Status_Failed'
					},
					{
						code: '500059',
						name: 'Toy_Exist_QiUi_App'
					}
				],
				// 3. HttpStatus.java 影子数据
				httpData: [{
						code: '200',
						name: 'SUCCESS'
					},
					{
						code: '201',
						name: 'CREATED'
					},
					{
						code: '202',
						name: 'ACCEPTED'
					},
					{
						code: '204',
						name: 'NO_CONTENT'
					},
					{
						code: '301',
						name: 'MOVED_PERM'
					},
					{
						code: '303',
						name: 'SEE_OTHER'
					},
					{
						code: '304',
						name: 'NOT_MODIFIED'
					},
					{
						code: '400',
						name: 'BAD_REQUEST'
					},
					{
						code: '401',
						name: 'UNAUTHORIZED'
					},
					{
						code: '403',
						name: 'FORBIDDEN'
					},
					{
						code: '404',
						name: 'NOT_FOUND'
					},
					{
						code: '405',
						name: 'BAD_METHOD'
					},
					{
						code: '409',
						name: 'CONFLICT'
					},
					{
						code: '415',
						name: 'UNSUPPORTED_TYPE'
					},
					{
						code: '500',
						name: 'ERROR'
					},
					{
						code: '501',
						name: 'NOT_IMPLEMENTED'
					},
					{
						code: '601',
						name: 'WARN'
					}
				],
				// 4. MobileMsgTypeConstant.java 影子数据
				mqttData: [{
						code: 'mqtt_100009',
						name: 'MQTT_Type_MASTER_USER_UNLOCK_WEARER_NO_TITL'
					},
					{
						code: 'mqtt_100010',
						name: 'MQTT_Type_MASTER_USER_REFUSE_UNLOCK_WEARER_NO_TITLE'
					},
					{
						code: 'mqtt_h00000',
						name: 'MQTT_Type_Error'
					},
					{
						code: 'mqtt_h00001',
						name: 'MQTT_Notify_Successor'
					},
					{
						code: 'mqtt_h00002',
						name: 'MQTT_Device_Unlock'
					},
					{
						code: 'mqtt_h00003',
						name: 'MQTT_Device_Lock'
					},
					{
						code: 'mqtt_h00004',
						name: 'MQTT_Device_Timing_Unlock'
					},
					{
						code: 'mqtt_h00005',
						name: 'MQTT_Device_Clear_Timing_Unlock'
					},
					{
						code: 'mqtt_h00006',
						name: 'MQTT_Device_Query_Timing_Unlock'
					},
					{
						code: 'mqtt_h00007',
						name: 'MQTT_Device_Query_Device_State'
					},
					{
						code: 'mqtt_h00008',
						name: 'MQTT_Device_Shock_Immediately'
					},
					{
						code: 'mqtt_h00009',
						name: 'MQTT_Device_Shock_Continued_Five_Second'
					},
					{
						code: 'mqtt_h00010',
						name: 'MQTT_Device_Stop_Toy_Timing_Electric_Shock'
					},
					{
						code: 'mqtt_h00011',
						name: 'MQTT_Device_Clear_Toy_Timing_Electric_Shock'
					},
					{
						code: 'mqtt_h00012',
						name: 'MQTT_Device_Token'
					},
					{
						code: 'mqtt_h00013',
						name: 'MQTT_Device_Offline'
					},
					{
						code: 'mqtt_h00014',
						name: 'MQTT_Device_Lat_Location'
					},
					{
						code: 'mqtt_h00015',
						name: 'MQTT_Device_Set_Electric_Shock'
					},
					{
						code: 'mqtt_h00016',
						name: 'MQTT_Device_Set_WorkStatus'
					},
					{
						code: 'mqtt_h00017',
						name: 'MQTT_Device_Set_Show_Number'
					},
					{
						code: 'mqtt_h00018',
						name: 'MQTT_Device_Online'
					},
					{
						code: 'Server',
						name: 'Server_sender_Prefix'
					},
					{
						code: 'mqtt_h2001',
						name: 'MQTT_Toy_Message_Info'
					}
				]
			};
		},
		computed: {
			i18nTabs() {
				return [{
						key: 'param',
						label: this.$t('errHub.tabParam')
					},
					{
						key: 'service',
						label: this.$t('errHub.tabService')
					},
					{
						key: 'http',
						label: this.$t('errHub.tabHttp')
					},
					{
						key: 'mqtt',
						label: this.$t('errHub.tabMqtt')
					}
				];
			},
			// ⚡ 响应式清洗引擎：在此处统一实时动态拦截并组装各语言的真实翻译
			translatedDataGroups() {
				const mapI18n = (list, tabType) => {
					return list.map(item => {
						// 解决 401 别名冲突问题
						const i18nKey = (tabType === 'http' && item.code === '401') ? '401_http' : item.code;
						return {
							code: item.code,
							name: item.name,
							msg: this.$t(`errHub.codes.${i18nKey}`) // 100% 走当前 I18n 语言包读取
						};
					});
				};

				return {
					param: mapI18n(this.paramData, 'param'),
					service: mapI18n(this.serviceData, 'service'),
					http: mapI18n(this.httpData, 'http'),
					mqtt: mapI18n(this.mqttData, 'mqtt')
				};
			}
		},
		methods: {
			/**
			 * 统一过滤逻辑：基于已被 computed 完全翻译的最终形态进行实时筛选
			 */
			getFilteredData(tabKey) {
				const targetData = this.translatedDataGroups[tabKey] || [];

				if (!this.searchQuery.trim()) {
					return targetData;
				}

				const query = this.searchQuery.toLowerCase();
				return targetData.filter(item => {
					return (
						item.code.toLowerCase().includes(query) ||
						item.name.toLowerCase().includes(query) ||
						item.msg.toLowerCase().includes(query)
					);
				});
			}
		}
	};
</script>

<style scoped>
	.error-code-container {
		padding: 24px;
		max-width: 1200px;
		margin: 0 auto;
		font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
		color: #333333;
	}

	.page-header {
		margin-bottom: 24px;
		border-left: 4px solid #3b82f6;
		padding-left: 12px;
	}

	.page-header h2 {
		margin: 0 0 4px 0;
		font-size: 24px;
		color: #1e3a8a;
	}

	.page-header .subtitle {
		margin: 0;
		font-size: 14px;
		color: #6b7280;
	}

	.filter-bar {
		margin-bottom: 20px;
	}

	.search-input {
		width: 100%;
		max-width: 400px;
		padding: 10px 16px;
		font-size: 14px;
		border: 1px solid #d1d5db;
		border-radius: 6px;
		outline: none;
		transition: all 0.3s ease;
	}

	.search-input:focus {
		border-color: #3b82f6;
		box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
	}

	.tabs-header {
		display: flex;
		border-bottom: 2px solid #e5e7eb;
		margin-bottom: 16px;
		gap: 8px;
	}

	.tab-btn {
		padding: 12px 20px;
		font-size: 15px;
		background: transparent;
		border: none;
		cursor: pointer;
		color: #4b5563;
		position: relative;
		font-weight: 500;
		display: flex;
		align-items: center;
		gap: 6px;
		transition: color 0.2s ease;
	}

	.tab-btn:hover {
		color: #2563eb;
	}

	.tab-btn.active {
		color: #2563eb;
	}

	.tab-btn.active::after {
		content: '';
		position: absolute;
		bottom: -2px;
		left: 0;
		right: 0;
		height: 2px;
		background-color: #2563eb;
	}

	.badge {
		background-color: #f3f4f6;
		color: #6b7280;
		font-size: 11px;
		padding: 2px 6px;
		border-radius: 10px;
		font-weight: bold;
	}

	.tab-btn.active .badge {
		background-color: #eff6ff;
		color: #2563eb;
	}

	.table-wrapper {
		background: #ffffff;
		border: 1px solid #e5e7eb;
		border-radius: 8px;
		overflow: hidden;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
	}

	.error-table {
		width: 100%;
		border-collapse: collapse;
		text-align: left;
		font-size: 14px;
	}

	.error-table th {
		background-color: #f9fafb;
		padding: 14px 16px;
		font-weight: 600;
		color: #374151;
		border-bottom: 1px solid #e5e7eb;
	}

	.error-table td {
		padding: 12px 16px;
		border-bottom: 1px solid #f3f4f6;
		vertical-align: middle;
	}

	.error-table tbody tr:hover {
		background-color: #f9fafb;
	}

	.code-tag {
		font-family: "Courier New", Courier, monospace;
		background-color: #fef2f2;
		color: #dc2626;
		padding: 4px 8px;
		border-radius: 4px;
		font-weight: 600;
		border: 1px solid #fee2e2;
		display: inline-block;
	}

	.constant-name {
		font-family: Consolas, Monaco, monospace;
		color: #059669;
		font-size: 13px;
	}

	.message-text {
		color: #1f2937;
	}

	.empty-cell {
		text-align: center;
		padding: 40px !important;
		color: #9ca3af;
	}
</style>